/**
 * Cart Shipping Alert - Dynamic Progress Updates
 * Updates shipping threshold progress when cart changes
 */

class CartShippingAlert {
  constructor() {
    this.init();
  }

  init() {
    // Initialize alert elements
    this.reinitialize();

    // Subscribe to cart updates
    if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleCartUpdate.bind(this));
    }
  }

  reinitialize() {
    this.alert = document.querySelector('.cart-shipping-alert');
    if (!this.alert) return;

    this.threshold = parseInt(this.alert.dataset.threshold) || 28900; // Default 289€
    this.progressFill = this.alert.querySelector('.cart-shipping-alert__progress-fill');
    this.textElement = this.alert.querySelector('.cart-shipping-alert__text');
  }

  handleCartUpdate(event) {
    // Re-initialize in case drawer was re-rendered
    this.reinitialize();

    if (!this.alert) return; // Cart might be empty now

    const cartTotal = event?.cart?.total_price || 0;
    this.updateProgress(cartTotal);
    this.updateText(cartTotal);
  }

  updateProgress(cartTotal) {
    if (!this.progressFill) return;

    let percent = Math.floor((cartTotal / this.threshold) * 100);
    if (percent > 100) percent = 100;

    this.progressFill.style.width = `${percent}%`;
    this.progressFill.dataset.progress = percent;
  }

  updateText(cartTotal) {
    if (!this.textElement) return;

    const remaining = this.threshold - cartTotal;

    if (remaining > 0) {
      // Format remaining amount (convert cents to euros with comma)
      const remainingFormatted = (remaining / 100).toFixed(2).replace('.', ',');
      this.textElement.innerHTML = `Plus que <strong>${remainingFormatted}&nbsp;€</strong> pour bénéficier de la livraison gratuite`;
    } else {
      this.textElement.innerHTML = `Vous bénéficiez de la <strong>livraison gratuite</strong> !`;
    }
  }
}

// Initialize when DOM ready - singleton instance
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.cartShippingAlertInstance = new CartShippingAlert();
  });
} else {
  window.cartShippingAlertInstance = new CartShippingAlert();
}
